import { render, staticRenderFns } from "./Square.vue?vue&type=template&id=5a8ab90a&scoped=true"
import script from "./Square.vue?vue&type=script&lang=js"
export * from "./Square.vue?vue&type=script&lang=js"
import style0 from "./Square.vue?vue&type=style&index=0&id=5a8ab90a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8ab90a",
  null
  
)

export default component.exports